<template lang="pug">
.md-layout
  .md-layout-item
    md-card#data-table
      md-card-header#header.md-card-header-icon.md-card-header-green
        .card-icon
          md-icon list_alt
        h4.title.inlineTitle
          | {{ title }}
        //- md-button.margin-left.margin-top(class='md-sm md-facebook' style='float: right;')
        //-   md-icon(style='font-size: 24px !important;') print
        //-   md-tooltip(md-direction="bottom")
        //-     | Imprimir
        //- ExportJsonToCsv#csv-component(:dataTable="dataTable")
        VueJsonToCsv#csv-component(:json-data='result' csv-title="Histórico de Produtividade" :labels='titles' style='opacity: 0; pointer-events: none;')
        md-button.margin-left.margin-top(@click='generateFile()' :disabled='loadingCSV || dialogsGeneration' class='md-sm md-facebook' style='float: right;')
          template(v-if='!loadingCSV')
            md-icon(style='font-size: 24px !important;') table_view
            md-tooltip(md-direction="bottom")
              | {{$t('localDataTable.generateSpreadsheet')}}
          template(v-else)
            v-progress-circular(
              size='24',
              width='2',
              style='transition: 0.1s; height: 33px;'
              color='#fff'
              indeterminate)
        //- md-button.margin-top(class='md-sm md-facebook' style='float: right; margin-right: 0px;')
        //-   md-icon(style='font-size: 24px !important;') picture_as_pdf
        //-   md-tooltip(md-direction="bottom")
        //-     | Exportar PDF
        slot(name='title-left')
      md-card-content
        md-progress-bar.md-primary(
          :class='{ invisible: !delayedLoading }'
          md-mode='query'
          style='margin-bottom: 0px;')
        md-table.paginated-table.table-striped.table-hover(
          id='productivityList'
          v-model='currentPageData',
          :md-sort='currentSort',
          @update:mdSort='$emit("update:currentSort", $event)'
          :md-sort-order='currentSortOrder',
          @update:mdSortOrder='$emit("update:currentSortOrder", $event)'
          :md-sort-fn='customSort',
          :md-selected-value.sync='selected'
          @update:mdSelectedValue='$emit("selected-items", $event)')
          md-table-toolbar(v-if='!customHeader')
            md-field
              label(for='pages') {{ $t("commonPhrases.perPage") }}
              md-select(v-model='pagination.perPage' name='pages')
                md-option(
                  v-for='item in pagination.perPageOptions',
                  :key='item',
                  :label='item',
                  :value='item') {{ item }}
            md-field
              md-input.mb-3(
                type='search'
                clearable
                style='width: 200px;',
                :placeholder='$t("commonWords.search") + "..."',
                :value='searchQuery'
                @input='updateSearch')
          template(v-else)
            slot(name='custom-header' :pagination='pagination')
          md-table-toolbar(
            v-if='selectable'
            slot='md-table-alternate-header'
            slot-scope='{ count }'
            style='position: relative;')
            .backgroundRed.md-toolbar
              .md-toolbar-section-start
                | {{ count }}
                | {{ count > 1 ? $t("commonWords.itemsSelected") : $t("commonWords.itemSelected") }}
              .md-toolbar-section-end(v-if='selectable')
                div(v-if='!allowDeleteSelected')
                  slot(name='deleteSelectedMessage')
                md-button.md-simple.md-github(
                  :disabled='isReadOnly || !allowDeleteSelected'
                  @click='$emit("delete-selected", selected)')
                  md-icon delete
                  | {{ $t("commonWords.delete") }}
                md-button.md-simple.md-github(@click='clearSelection') {{ $t("commonWords.cancel") }}
          md-table-row(
            slot='md-table-row'
            slot-scope='props'
            :md-selectable='selectable ? "multiple" : undefined'
            @click='$emit("click-row", props)'
            style='cursor: pointer;',
            :class='rowClasses(props.item)')
            slot(name='cells' v-bind='props')
      md-card-actions(md-alignment='space-between')
        div
          p.card-category
            | {{ $t("commonWords.showingItems", { from: from + 1, to: to, total: total }) }}
        slot(name='footer' :pagination='pagination')
        pagination.pagination-no-border.pagination-success(
          v-model='pagination.currentPage'
          @input='$emit("update:currentPage", pagination.currentPage)',
          :per-page='pagination.perPage',
          :total='total')
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import enumPropValidator from '@/helpers/enumPropValidator'
import debounce from 'lodash.debounce'
import VueJsonToCsv from 'vue-json-to-csv'
import Swal from 'sweetalert2'
import * as moment from 'moment'
import { selectedLocale } from '@/plugins/i18n'

export default {
  model: {
    prop: 'data'
  },
  props: {
    data: { type: Array, default: Array },
    title: { required: true, type: String },
    isReadOnly: { default: false, type: Boolean },
    selectable: { type: Boolean, default: true },
    currentSort: { type: String },
    currentSortOrder: {
      type: String,
      default: 'asc',
      ...enumPropValidator('md-sort-order', ['asc', 'desc'])
    },
    customSort: { required: false, type: Function },
    customTotal: { required: true, type: Number },
    customHeader: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    rowClasses: { type: Function, default: () => ({}) },
    allowDeleteSelected: { type: Boolean, default: true },
    dataTable: { required: true }
  },
  components: {
    Pagination,
    VueJsonToCsv
  },
  watch: {
    pagination: {
      handler: 'updatePagination',
      deep: true
    },
    loading (value) {
      if (value === false) {
        const vm = this
        setTimeout(() => {
          vm.delayedLoading = value
        }, 500)
      } else {
        this.delayedLoading = value
      }
    }
  },
  computed: {
    to () {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from () {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    total () {
      return this.customTotal ?? (this.data?.length || 0)
    },
    currentPageData () {
      return this.data?.slice((this.pagination.currentPage - 1) * this.pagination.perPage, this.pagination.currentPage * this.pagination.perPage)
    }
  },
  data () {
    return {
      pagination: [],
      searchQuery: '',
      selected: [],
      delayedLoading: false,
      dialogsGeneration: false,
      loadingCSV: false,
      progressGeneration: 0,
      result: [],
      titles: {}
    }
  },
  methods: {
    updateSearch: debounce(function (value) {
      this.searchQuery = value
      this.$emit('search-query', value)
    }, 400),
    updatePagination (pagination, oldPagination) {
      this.$emit('pagination', pagination, oldPagination)
    },
    clearSelection () {
      this.selected = []
      this.$emit('clear-selection')
    },
    resetPagination () {
      this.pagination = {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50]
      }
    },
    async generateFile () {
      // const totalItems = JSON.parse(JSON.stringify(this.customTotal))
      // this.progressGeneration = 0
      // if (totalItems > 1000) {
      //   this.dialogsGeneration = true
      // }
      this.loadingCSV = true
      try {
        this.table = []
        this.titles = {
          cpf: { title: this.$t('localDataTable.cpf') },
          email: { title: this.$t('localDataTable.email') },
          operator: { title: this.$t('localDataTable.operator') },
          rules: { title: this.$t('localDataTable.rules') },
          memberQueue: { title: this.$t('localDataTable.memberInQueues') },
          hideQueue: { title: this.$t('localDataTable.hiddenInTheQueues') },
          registerDate: { title: this.$t('localDataTable.dateRegister') },
          firstAttendDate: { title: this.$t('localDataTable.dateOfFirstCall') }
        }

        this.dataTable.forEach(elm => {
          let element = Object.assign({}, elm)
          const row = element.allAttendOperator
          delete element.allAttendOperator
          this.cells = {}
          row.forEach((el, index) => {
            const _value = el.date ? this.formatDate(el.date) : 'Total'
            this.cells[_value] = el.totalAttend || el.value || 0
            if (this.table.length === 0) {
              const cellTitle = {}
              cellTitle[_value] = { title: _value }
              this.titles = { ...this.titles, ...cellTitle }
            }
          })
          element.hideQueue = element.hideQueue || '-'
          element.registerDate = element.registerDate ? this.formatDate(element.registerDate) : '-'
          element.firstAttendDate = element.firstAttendDate ? this.formatDate(element.firstAttendDate) : '-'

          this.table.push({ ...element, ...this.cells })
        })
        this.result = this.table
        this.isButton = !!this.result
        this.$nextTick(() => {
          document.querySelector('#csv-component').click()
        })
      } catch (error) {
        // if (error.message === 'Cancelado pelo usuário.') {
        //   Swal.fire({
        //     icon: 'error',
        //     title: 'Cancelado.'
        //   })
        // } else {
        Swal.fire({
          icon: 'error',
          title: this.$t('localDataTable.errorGeneratingCsv')
        })
        // }
      } finally {
        // this.dialogsGeneration = false
        this.loadingCSV = false
        // setTimeout(() => {
        //   this.progressGeneration = 0
        // }, 100)
      }
    },
    formatDate (date) {
      return moment(date).locale(selectedLocale).format('L')
    }
  },
  created () {
    this.resetPagination()
  },
  mounted () {
    this.$nextTick(() => {
      const headers = this.$el.querySelectorAll('th .md-table-head-container .md-table-head-label')

      headers.forEach(el => {
        let title = el.textContent
        el.setAttribute('title', title)
      })
      for (let i = 8; i < headers.length; i++) {
        headers[i].setAttribute('style', 'padding-right: 5px; text-align: right !important;')
      }
    })
  }
}
</script>

<style lang="css">
.invisible {
  visibility: hidden !important;
}
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
.md-checkbox.md-checked .md-checkbox-container:after {
  border-color: #33b231 !important;
  top: 1px !important;
  left: 6px !important;
}
#productivityList .md-table-cell-container {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 250px;
}

#productivityList .md-table-head {
  min-width: 266px;
  width: 266px;
  padding: 12px 0px !important;
}

#productivityList #dateValueId .md-table-head-label {
  padding-right: 0;
  text-align: right !important;
}

#productivityList #dateValueId .md-table-cell-container {
  padding-right: 0;
  text-align: right !important;
}

.md-table-alternate-header {
  top: 20px !important;
}
#productivityList .md-content > table > tbody > .md-table-row > .md-table-cell > .md-table-cell-container {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  display: block;
  -webkit-box-pack: none;
  -ms-flex-pack: none;
  justify-content: none;
}
#productivityList .md-content > table > thead > tr > .md-table-head > .md-table-head-container > .md-table-head-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  text-align: left;
}
#productivityList .md-content > table > thead > tr > .md-table-head:last-child > .md-table-head-container > .md-table-head-label {
  padding-right: 0px !important;
  text-align: right;
}
#productivityList .md-content > table > tbody > .md-table-row > .md-table-cell:hover > .md-table-cell-container {
  text-overflow: clip;
  white-space: normal;
  word-break: break-all;
}

</style>
